export const localeDatepicker = {
	"en": "en-GB",
	"si": "en-GB",
};

/**
 * return right locale for lib
 * @alias Ptx.locale.getLocale
 * @param lib
 * @param locale
 */
export function getLocale(lib, locale) {
	if (typeof locale == 'undefined') {
		locale = Ptx.lang;
	}
    if (Ptx.locale[lib][locale]) {
    	return Ptx.locale[lib][locale];
    } else {
    	return locale;
    }
}
